module.exports = __webpack_public_path__ + "img/nota_folio.9643fdb6.png";